<template>
    <v-row dense>
        <v-col class="text-center">
            <p class="caption font-weight-light">Breeze Connect Online Payment Page v{{appVersion}}</p>

        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "Footer",
        data() {
            return {
                appVersion: process.env.VUE_APP_VERSION || '0'
            }
        }
    }
</script>